import React from "react";
import "./fasilitas.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Fasilitasimages from "./fasilitas.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faGraduationCap,
  faHouse,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";

const fasilitas = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="fasilitas" className="fasilitas">
      <div className="container-fasilitas">
        <div className="judul-fasilitas">
          <h1>Cluster Facillities</h1>
        </div>
        <div className="container-card1">
          <div className="kartu1">
            <Slider {...settings}>
              {Fasilitasimages.map((image, index) => (
                <div>
                  <img
                    className="kartugambar2"
                    key={index}
                    src={image}
                    alt="athena"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default fasilitas;
